import { useRef, type ReactNode } from "react";
import { gsap, MOTION_OK, useGSAP } from "@/lib/gsap";

export interface RevealProps {
  children: ReactNode;
  className?: string;
  /** Stagger offset in seconds. */
  delay?: number;
}

/**
 * 스크롤 진입 연출: 살짝 올라오며 나타나요(한 번만, 되튐 없이).
 *
 * ScrollTrigger 를 쓰면 화면에 이미 들어와 있는 요소는 즉시 재생되고, 아래에 있는 요소는
 * 상단 85% 선을 넘을 때 재생돼요 — 뷰포트 맨 아래에서 시작하면 사용자가 도달했을 땐 이미
 * 끝나 있어서 연출이 보이지 않아요.
 */
export function Reveal({ children, className, delay = 0 }: RevealProps) {
  const ref = useRef<HTMLDivElement>(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        gsap.from(ref.current, {
          opacity: 0,
          y: 24,
          duration: 0.55,
          delay,
          ease: "power3.out",
          scrollTrigger: { trigger: ref.current, start: "top 85%", once: true },
        });
      });
    },
    { scope: ref }
  );

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}

export default Reveal;
